import React from 'react';
import {Button, Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';

export default class ModalConfirm extends React.Component {
    constructor(props) {
        super(props);
        this.toggle = this.toggle.bind(this);
    }

    toggle() {
        this.cancel();
    }

    confirm() {
        this.props.confirm();
    }

    cancel() {
        this.props.cancel();
    }


    componentWillReceiveProps(nextProps) {
        if (nextProps)
            this.setState({visible: nextProps.visible})
    }

    render() {
        return (
            <Modal isOpen={true} toggle={this.toggle} className={this.props.className}>
                <ModalHeader toggle={this.toggle}>{this.props.title}</ModalHeader>
                <ModalBody>
                    {this.props.body}
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={() => this.confirm()}>Confirm</Button>{' '}
                    <Button color="secondary" onClick={() => this.cancel() }>Cancel</Button>
                </ModalFooter>
            </Modal>
        );
    }
}
